// extracted by mini-css-extract-plugin
export default {"pagination":"bJ6Q6EEoah0TEmc3VxIq","pageButton":"wJk3TALOXGXrKAPeBVrU","active":"RIwyx0qtgkqjE6NFkKjN"};